import { Divider } from '@eventbrite/eds-divider';
import loadable from '@loadable/component';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TrendingSearchesAnchor } from './components/TrendingSearchesAnchor';
import './SearchPivotsContainer.scss';
import {
    getTrendingSearchData,
    hasEventResults,
    isNextDisabled,
} from './selectors';

const SearchPivotSuggestions = loadable(
    () => import('./SearchPivotSuggestionsContainer'),
);

/**
 * Suggested actions for the user to take given low, empty, or
 * end of search results.
 *
 * Always displays the trending searches footer.
 *
 * @param {*} props
 */
interface SearchResultsPivotsProps {
    isLoading?: boolean;
    hasEventResults?: boolean;
    isNextDisabled?: boolean;
    trendingSearchData: {
        path?: string;
        text?: object;
    };
}

export const SearchResultsPivots = (props: SearchResultsPivotsProps) => {
    const { isLoading, hasEventResults, isNextDisabled } = props;
    const shouldRenderSuggestions =
        !isLoading && (!hasEventResults || isNextDisabled);

    return (
        <div className="search-result-pivots">
            {shouldRenderSuggestions && <SearchPivotSuggestions />}
            <div className="eds-l-pad-top-6 eds-l-pad-bot-10">
                <Divider color="ui-200" />
                <TrendingSearchesAnchor
                    trendingSearchData={props.trendingSearchData}
                />
            </div>
        </div>
    );
};

interface SearchResultsPivotsState {
    pagination: {
        loading?: boolean;
    };
    location: {
        slug: string;
        currentPlace: string;
        currentPlaceParent: string;
        trendingSearchCities: string[][];
    };
    app: {
        domain?: string;
    };
    shouldShowTrendingSearchPageLink?: boolean;
}

const _mapStateToProps = (state: SearchResultsPivotsState) => ({
    isLoading: state.pagination.loading,
    isNextDisabled: isNextDisabled(state),
    hasEventResults: hasEventResults(state),
    trendingSearchData: getTrendingSearchData(
        state.location,
        state.app.domain,
        state.shouldShowTrendingSearchPageLink,
    ),
});

const enhance = compose(connect(_mapStateToProps));

export const SearchPivotsContainer = enhance(SearchResultsPivots);
